import * as ngRouter from '@angular/router'
import * as store from '@attain-apps/fe/web/main/lib/store'

import * as models from '../models'

import type { Router } from './feature'

export class Selectors {
  // NOTE: intentionally missing return type so that type can be inferred
  public readonly everything

  // NOTE: intentionally missing return type so that type can be inferred
  public readonly isNavigating
  // NOTE: intentionally missing return type so that type can be inferred
  public readonly openRequests

  // NOTE: intentionally missing return type so that type can be inferred
  public readonly url

  // NOTE: intentionally missing return type so that type can be inferred
  public readonly rawUrl

  // NOTE: intentionally missing return type so that type can be inferred
  public readonly fragment

  // NOTE: intentionally missing return type so that type can be inferred
  public readonly routeParams
  // NOTE: intentionally missing return type so that type can be inferred
  public readonly getRouteParam

  // NOTE: intentionally missing return type so that type can be inferred
  public readonly queryParams
  // NOTE: intentionally missing return type so that type can be inferred
  public readonly getQueryParam

  // NOTE: intentionally missing return type so that type can be inferred
  public readonly encodedQueryParamsFullObject
  // NOTE: intentionally missing return type so that type can be inferred
  public readonly getEncodedQueryParam

  public readonly getUrlWith

  constructor(router: Router) {
    this.everything = router.state.project(state => state.state)

    this.openRequests = router.state.project(state => state.openRequests)
    this.isNavigating = this.openRequests.project(requests => requests > 0)

    this.rawUrl = this.everything.project(state => state.url)
    this.url = this.rawUrl.project(url => router.urlSerializer.parse(url))

    this.fragment = this.everything.project(state => state.fragment)

    this.routeParams = this.everything.project(state => state.routeParams)
    this.getRouteParam = router.createSelectorMethod((param: string) =>
      this.routeParams.project(routeParams => routeParams[param]),
    )

    this.queryParams = this.everything.project(state => state.queryParams)
    this.getQueryParam = router.createSelectorMethod((param: string) =>
      this.queryParams.project(queryParams => queryParams[param]),
    )

    this.encodedQueryParamsFullObject = this.everything.project(
      state => state.encodedQueryParamsFullObject,
    )
    this.getEncodedQueryParam = router.createSelectorMethod(
      (scope: models.EncodedQueryParam.Scope) =>
        this.encodedQueryParamsFullObject.project(payload =>
          scope.reduce<unknown>(
            // NOTE: we handle any possible value for prev[key], so it doesn't
            // matter if it is actually a valid key of prev
            (prev, key) => prev?.[key as keyof typeof prev],
            payload,
          ),
        ),
    )

    this.getUrlWith = router.createSelectorMethod((request: models.Request) => {
      const { url, path, fragment } = request
      if (url) {
        return store.selectors.Selector.always(
          url instanceof ngRouter.UrlTree
            ? url
            : router.urlSerializer.parse(url),
        )
      }
      return this.encodedQueryParamsFullObject.project(
        // NOTE: Angular merges the given request with the current URL, so we
        // need to explicitly listen to the current URL so that NgRx knows to
        // rerun the producer whenever the URL changes
        this.url.asSelector,
        encodedQueryParamsFullObject =>
          // NOTE: Angular is incorrectly typed to suggest that it can only
          // handle mutable lists. That is not actually the case
          router.ngRouter.createUrlTree((path as Mutable<typeof path>) ?? [], {
            fragment,
            queryParams: models.Request.synthesizeQueryParams(
              request,
              encodedQueryParamsFullObject,
            ),
            queryParamsHandling: 'merge',
          }),
      )
    })
  }
}
